"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWriter = exports.FormReader = void 0;
var components_1 = require("./components");
Object.defineProperty(exports, "FormReader", { enumerable: true, get: function () { return components_1.FormReader; } });
Object.defineProperty(exports, "FormWriter", { enumerable: true, get: function () { return components_1.FormWriter; } });
__exportStar(require("./utils/media"), exports);
//# sourceMappingURL=index.js.map